import { ChartsRadialGrid } from './ChartsRadialGrid';

export { type ChartsRadialGridProps, ChartsRadialGrid } from './ChartsRadialGrid';

/**
 * @deprecated radial grid is now stable, import `ChartsRadialGrid` instead
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const Unstable_ChartsRadialGrid = ChartsRadialGrid;

export { chartsRadialGridClasses } from './chartsRadialGridClasses';
export type { ChartsRadialGridClasses, ChartsRadialGridClassKey } from './chartsRadialGridClasses';
